/**
 * Handles the JavaScript associated with sidebar components
 */

class CountdownClock {
    constructor(clock) {

            // Caching variables
            this.browser = window.navigator.userAgent.toLowerCase();
            this.clock = clock;
            this.offset = offset;
            // Get the message instance
            this.jsMsgHook = clock.querySelector('.sidebar-message');
            // Get the Endtime
            var endtime = this.endtime = clock.querySelector('.sidebar-timer__wrap').getAttribute('data-endtime');
            var offset = this.offset = clock.querySelector('.sidebar-timer__wrap').getAttribute('data-endtime-offset');
            this.timeinterval = undefined;

            // Run the function once before interval to avoid a delayed start
            this.updateClock(clock, endtime, offset);

            // Set up the time interval to tick the clock down
            this.executeInterval(clock, endtime, offset);

        } // constructor()

    // Pulling this out of the loop
    executeInterval(clock, endtime, offset) {

            clock = clock || this.clock;
            endtime = endtime || this.endtime;
            offset = offset || this.offset;

            this.timeinterval = setInterval(function() {

                // Update the clock every second
                this.updateClock(clock, endtime, offset);

            }.bind(this), 1000);

        } // executeInterval()

    checkClientDST() {
        var dateObj = new Date();
        var jan = new Date(dateObj.getFullYear(), 0, 1);
        var jul = new Date(dateObj.getFullYear(), 6, 1);
        var stdTimezoneOffset = Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());

        return dateObj.getTimezoneOffset() < stdTimezoneOffset;
    }

    // Calculate the remaining time
    getTimeRemaining(endtimeRaw, countBy, offset) {
            // Some browsers need a "T" in there...

            var endtimeClean = endtimeRaw.replace(/\s/, 'T');
            if (this.browser.indexOf('firefox') > -1) endtimeClean = endtimeClean + "Z";
            var endtime = new Date(endtimeClean);

            var hourMilis = 3600000;
            var additionalOffSet = (this.checkClientDST) ? 1 : 0;

            // Eastern Time Offset
            var offset = offset + additionalOffSet || -5.0 + additionalOffSet;
            var clientDate = new Date();
            var utc = clientDate.getTime();
            var current = new Date(utc + (hourMilis * offset));

            var t = Date.parse(endtime) - Date.parse(current);
            var seconds = Math.floor((t / 1000) % 60);
            var minutes = Math.floor((t / 1000 / 60) % 60);
            var hours = (countBy.indexOf('hour') > -1) ? Math.floor(t / (1000 * 60 * 60)) : Math.floor((t / (1000 * 60 * 60)) % 24);
            var days = (countBy.indexOf('hour') > -1) ? 0 : Math.floor(t / (1000 * 60 * 60 * 24));

            // Build out the JSON object
            return {
                'total': t,
                'days': (days > 0) ? days : 0,
                'hours': (hours > 0) ? hours : 0,
                'minutes': (minutes > 0) ? minutes : 0,
                'seconds': (seconds > 0) ? seconds : 0
            };

        } // getTimeRemaining()

    // Update the DOM with the new time
    updateClock(clock, endtime) {
            var clockWrap = clock.querySelector('.sidebar-timer__wrap');
            var expirationAction = clockWrap.getAttribute('data-expiration');
            var countBy = clockWrap.getAttribute('data-showby');
            var timer = clock.querySelector('.sidebar-timer');

            var t = this.getTimeRemaining(endtime, countBy);
            var days = clock.querySelector('.timer-days .sidebar-timer__value');
            var hours = clock.querySelector('.timer-hours .sidebar-timer__value');
            var minutes = clock.querySelector('.timer-minutes .sidebar-timer__value');
            var seconds = clock.querySelector('.timer-seconds .sidebar-timer__value');

            days.innerHTML = t.days;
            if (t.hours <= 99) {
                hours.innerHTML = t.hours;
            } else {
                hours.innerHTML = t.hours;
                timer.classList.add('is-hourly-wide');
            }
            minutes.innerHTML = t.minutes;
            seconds.innerHTML = t.seconds;

            if (countBy.indexOf('hour') > -1 || t.days <= 0) {
                timer.classList.add('is-hourly');
            }

            if (t.total === NaN || t.total <= 0) {
                let clockWrapClassList = clockWrap.classList;
                // The timer has expired, so hide it
                clockWrapClassList.add('is-removed');
                clockWrapClassList.remove('is-active');

                // If we should be displaying the message upon expiration, do so now
                if (expirationAction === 'display-message') {
                    let messageTagClassList = clock.querySelector('.sidebar-message').classList;
                    messageTagClassList.remove('is-removed');
                    messageTagClassList.remove('is-active');

                    clock.classList.remove('is-removed');

                } else if (expirationAction === 'hide-component') {

                    clock.classList.add('is-removed');

                } // if

                // Stop the timer
                clearInterval(this.timeinterval);

            } // if ( t.total <= 0 )

        } // updateClock()

} // Sidebar {}

export default CountdownClock;


// WEBPACK FOOTER //
// ./assets/components/sidebar/CountdownClock.js